import './styles/MenuButtonStyle.css';

interface MenuButtonProps {
  onClickButton(): void;
  buttonTitle: any;
  buttonContent: any;
  buttonClass?: string;
  iconClass?: string;
  disabled?: boolean;
}
const MenuButton: React.FC<MenuButtonProps> = ({
  onClickButton,
  buttonTitle,
  buttonContent,
  buttonClass,
  iconClass,
  disabled,
}) => {
  return (
    <div className="menu-button-container">
      <p className="menu-button-title">{buttonTitle}</p>
      <button
        disabled={disabled}
        onClick={() => onClickButton()}
        className={`menu-button ${buttonClass} ${
          disabled ? 'disabled' : 'stepOn'
        }`}
      >
        <img
          className={`menu-button-icon ${iconClass}`}
          alt={buttonContent.toString()}
          src={buttonContent}
        />
      </button>
    </div>
  );
};

export { MenuButton };
